import {Component, Inject, OnInit} from '@angular/core';
import {combineLatest, exhaustMap, iif, Observable, of, tap} from 'rxjs';
import {SuppliersService} from '../../../services/suppliers.service';
import {ActivatedRoute} from '@angular/router';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {FormControl} from '@angular/forms';
import {debounceTime, map, startWith} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {APP_GUIDS, AppGuids} from '../../../app.guids';
import {ConfirmDialogComponent} from '../../dialogs/confirm-dialog.component';
import {PmCreateCommentComponent} from '../pm-create-comment/pm-create-comment.component';
import {PmCreateIndexComponent} from '../pm-create-index/pm-create-index.component';
import {CoreService, ProleisObject, RequestParam, UserService} from "@proleis/proleis-rest-client";
import {NotificationService} from "@proleis/proleis-web-app";

@Component({
  selector: 'ps-pm-snrs',
  templateUrl: 'pm-snrs.component.html',
  styleUrls: ['pm-snrs.component.scss']
})
export class PmSnrsComponent implements OnInit {

  construction$: Observable<ProleisObject>;
  indices$: Observable<ProleisObject[]>;
  selectedIndex: ProleisObject;
  snrs$: Observable<ProleisObject[]>;
  searchFormControl: FormControl;
  comments$: Observable<ProleisObject[]>;
  user: ProleisObject;

  constructor(private ps: SuppliersService, public route: ActivatedRoute, private bottomSheet: MatBottomSheet, private dialog: MatDialog,
              private cs: CoreService, @Inject(APP_GUIDS) private guids: AppGuids, private ns: NotificationService, private us: UserService) {
  }

  ngOnInit() {
    this.refreshIndices();
    this.searchFormControl = new FormControl<string>('');
    this.construction$ = this.ps.getPmConstruction(this.route.snapshot.params.constructionId);
    this.us.getCurrentUser().subscribe(user => this.user = user);
  }

  refreshIndices() {
    this.indices$ = this.ps.getPmIndices(this.route.snapshot.params.constructionId).pipe(
      tap(indices => {
        if (localStorage.getItem('selectedIndexId')) {
          this.selectedIndex = indices.filter(index => index.OBJECT_ID.valueOf() == localStorage.getItem('selectedIndexId').valueOf())[0];
          this.getComments();
          this.refreshSnrs();
        }
      })
    );
  }

  onChangeIndex(event) {
    localStorage.setItem('selectedIndexId', event.OBJECT_ID.toString());
    this.refreshSnrs();
  }

  refreshSnrs() {
    this.snrs$ = this.ps.getPmSnrs(this.route.snapshot.params.constructionId, this.selectedIndex.OBJECT_ID);
    const filter$ = this.searchFormControl.valueChanges.pipe(
      debounceTime(250),
      startWith(''),
      map(searchExpression => searchExpression.toLowerCase())
    );

    this.snrs$ = combineLatest([this.snrs$, filter$]).pipe(
      exhaustMap(([indices, filter]) => {
        return iif(() => filter === '',
          of(indices),
          of(indices.filter(
            snr => snr.NAME.toLowerCase().includes(filter)
          ))
        );
      })
    );
  }

  deleteSnr(snr: ProleisObject) {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: snr.NAME + ' wirklich löschen?'
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.cs.executeAction(snr.OBJECT_ID, '§' + this.guids.GUID_ACTION_DELETE_PM_OBJECT).subscribe(result => {
          this.ns.showNotification('SNR ' + snr.NAME + ' wurde gelöscht.');
        });
      }
    });
  }

  createIndex() {
    this.bottomSheet.open(PmCreateIndexComponent, {
      data: {
        constructionId: this.route.snapshot.params.constructionId
      }
    }).afterDismissed().subscribe(result => {
      this.refreshIndices();
    });
  }

  deleteIndex(index: ProleisObject) {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: index.NAME + ' wirklich löschen?'
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.cs.executeAction(index.OBJECT_ID, '§' + this.guids.GUID_ACTION_DELETE_PM_OBJECT).subscribe(result => {
          this.ns.showNotification('SNR ' + index.NAME + ' wurde gelöscht.');
        });
      }
    });
  }

  getAuthorClass(comment: ProleisObject) {
    if (comment.ERSTELLER_ID === this.user?.OBJECT_ID) {
      return 'comment-self';
    } else {
      return 'comment-other';
    }
  }

  getComments() {
    const aliasFields = 'USERNAME=BENUTZER_ID.TEXT';
    if (this.selectedIndex?.OBJECT_ID) {
      this.comments$ = this.ps.getPmIndexComments(this.route.snapshot.params.constructionId, this.selectedIndex.OBJECT_ID, aliasFields);
    }
  }

  createComment() {
    this.dialog.open(PmCreateCommentComponent).afterClosed().subscribe(result => {
      if (result) {
        const param: RequestParam = {
          'COMMENT': result
        };
        this.cs.executeAction(this.selectedIndex.OBJECT_ID, '§' + this.guids.GUID_ACTION_COMMENT, param).subscribe(result => {
          this.getComments();
        });
      }
    });
  }
}
